import type { Course } from "../../backend/api/learning";
import { Checkbox } from "../ui/checkbox";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { Badge } from "../ui/badge";

export function CourseAssignmentChoices({
  courses,
  values,
  onChange,
  disabled,
  lockedIds = [],
  completedIds = [],
  defaultRequired = false,
}: {
  courses: Course[];
  values: Record<string, boolean>;
  onChange: (id: string, value: boolean | null) => void;
  disabled?: boolean;
  lockedIds?: string[];
  completedIds?: string[];
  defaultRequired?: boolean;
}) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Course</TableHead>
          <TableHead className="text-center">Assigned</TableHead>
          <TableHead className="text-center">Required</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {courses.map((course) => (
          <TableRow key={course.id}>
            <TableCell>
              <span className="font-medium">{course.title}</span>
              {completedIds.includes(course.id) && (
                <Badge className="ml-2" variant="outline">
                  Completed
                </Badge>
              )}
            </TableCell>
            <TableCell className="text-center">
              <Checkbox
                aria-label={`Assign ${course.title}`}
                checked={values[course.id] !== undefined}
                disabled={disabled || lockedIds.includes(course.id)}
                onCheckedChange={(checked) =>
                  onChange(course.id, checked ? defaultRequired : null)
                }
              />
            </TableCell>
            <TableCell className="text-center">
              <Checkbox
                aria-label={`Require ${course.title}`}
                checked={values[course.id] === true}
                disabled={disabled || values[course.id] === undefined}
                onCheckedChange={(checked) =>
                  onChange(course.id, checked === true)
                }
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
